import React, { useEffect, useState } from "react";
import { appFetchJson } from "../../../utils/http";
import apiRoutes from "../../../api/apiRoutes";

export default function VerDatosExportadosProani({ id, onClose = () => {} }) {
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState("");
  const [e, setE] = useState(null);

  useEffect(() => {
    if (!id) return;

    let cancelled = false;

    const load = async () => {
      setLoading(true);
      setErr("");

      try {
        const data = await appFetchJson(
          apiRoutes.proaniOut.detail(id)
        );
        if (!cancelled) setE(data);
      } catch (error) {
        console.error(error);
        if (!cancelled) {
          setErr("Error al cargar los datos exportados Proani.");
          setE(null);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    load();
    return () => {
      cancelled = true;
    };
  }, [id]);

  const rows = [
    ["Fecha", e?.dataFecha],
    ["Código Tipo", e?.codigoTipo],
    ["Nombre Archivo", e?.nombreArchivo],
    ["Línea", e?.textoLinea],
    ["Error", e?.descricaoError],
    ["Procesado", e?.codigoProcesadoLabel],
  ];

  return (
    <div className="modal-backdrop">
      <div className="modal-panel-lg">
        {/* HEADER */}
        <div className="modal-header">
          <h2 className="section-title">
            Datos Exportados Proani
          </h2>
        </div>

        {/* BODY */}
        <div className="modal-body">
          {loading && (
            <div className="py-6 text-center text-gray-600">
              Cargando…
            </div>
          )}

          {!loading && err && (
            <div className="py-6 text-center text-red-600">
              {err}
            </div>
          )}

          {!loading && !err && e && (
            <div className="form-grid">
              {rows.map(([label, value]) => (
                <Fila key={label} label={label} value={value} />
              ))}
            </div>
          )}
        </div>

        {/* FOOTER */}
        <div className="modal-footer">
          <div className="flex justify-end">
            <button className="btn-fil" onClick={onClose}>
              Volver
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

function Fila({ label, value }) {
  return (
    <div className="form-row">
      <div className="form-label">{label}:</div>
            <div className="value break-words whitespace-normal min-w-0">
        {value !== null && value !== undefined && value !== ""
          ? value
          : <span className="text-gray-400">—</span>}
      </div>
    </div>
  );
}
